class ChangeLinkFromQueryString {
    constructor(element, options) {
        this._element = element;
        this._options = options;

        this._init();
    }

    _init() {
        this._linkQuery = window.location.search;
        this._initialQueryString = this._element.search.substr(1);
        this._queryValue = this._getQueryValueFromURL();

        if(this._queryValue) {
            this.isLandingsPage && this._checkEnvironmentInQueryValue();
            this._changeLink();
        }
    }

    _getQueryValueFromURL() {
        this._options.queryKey.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        const regex = new RegExp(
            "[\\?&]" + this._options.queryKey + "=([^&#]*)"
        );

        const results = regex.exec(this._linkQuery);

        return results === null
            ? false
            : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    _changeLink() {
        this._element.href = this._queryValue;

        if (this._initialQueryString.length) {
            this._element.href.indexOf("?") === -1
                ? (this._element.href += `?${this._initialQueryString}`)
                : (this._element.href += `&${this._initialQueryString}`);
        }
    }

    _checkEnvironmentInQueryValue() {
        console.log(this.hasAZVZinLink, this.hasAZVZinQuery);
        if(this.hasAZVZinLink && !this.hasAZVZinQuery) {
            this._queryValue = this._queryValue.replace('mijnzz', 'mijnazvz');
        } else if(!this.hasAZVZinLink && this.hasAZVZinQuery) {
            this._queryValue = this._queryValue.replace('mijnazvz', 'mijnzz');
        }
    }

    get isLandingsPage() {
        return location.pathname.search('landingspage') !== -1;
    }

    get hasAZVZinLink() {
        return location.pathname.search('azvz') !== -1;
    }

    get hasAZVZinQuery() {
        return location.search.search('azvz') !== -1;
    }
}
